import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'

import { getCategoryTypes, getEventTypes } from 'selectors/entities'
import EventTypeSelectorCategory from './event-type-selector-category'
import EventTypeSelectorList from './event-type-selector-list'

import styles from './event-type-selector-container.css'

export const CATEGORIES = [
  { key: 'comedy', name: 'Comedy' },
  { key: 'culture', name: 'Culture' },
  { key: 'tasting', name: 'Food + Drink' },
  { key: 'cinema', name: 'Film' },
  { key: 'music', name: 'Music' },
  { key: 'nightlife', name: 'Nightlife' },
  { key: 'performance', name: 'Performance' },
  { key: 'sport', name: 'Sports' },
  { key: 'theatre', name: 'Theatre' },
  { key: 'venue_hire', name: 'Venue Hire' },
]

export class EventTypeSelectorContainer extends Component {

  constructor(props) {
    super(props)
    this.onCategoryChange = this.onCategoryChange.bind(this)
    this.onEventTypeChange = this.onEventTypeChange.bind(this)
  }

  componentWillMount() {
    this.setState({ categoryKey: null })
  }

  componentWillReceiveProps(nextProps) {
    // Set state here because initialValue is not availible on initial render
    if (this.state.categoryKey === null && nextProps.data.value) {
      this.setState({ categoryKey: this.props.eventTypes[nextProps.data.value].category })
    }
  }

  onCategoryChange(event) {
    this.props.data.onChange(null)
    this.setState({ categoryKey: event.target.value === '' ? null : event.target.value })
  }

  onEventTypeChange(id) {
    this.props.data.onChange(id)
  }

  render() {
    return (
      <div styleName="selector">
        <EventTypeSelectorCategory
          categories={CATEGORIES}
          value={this.state.categoryKey}
          onChange={this.onCategoryChange}
        />
        {this.state.categoryKey &&
          <EventTypeSelectorList
            types={this.props.categoryTypes[this.state.categoryKey]}
            value={this.props.data.value}
            onChange={this.onEventTypeChange}
          />
        }
      </div>
    )
  }

}

EventTypeSelectorContainer.propTypes = {
  categoryTypes: PropTypes.object,
  data: PropTypes.object,
  eventTypes: PropTypes.object,
}

const mapStateToProps = state => ({
  categoryTypes: getCategoryTypes(state),
  eventTypes: getEventTypes(state),
})

export default connect(mapStateToProps)(CSSModules(EventTypeSelectorContainer, styles))



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/field/event-type-selector/event-type-selector-container.js
 **/